import React, { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';

const TONES = [['friendly', 'Friendly (1–30 days)'], ['firm', 'Firm (31–60 days)'], ['final', 'Final notice (61+ days)']];

export const ReminderTemplatesSettings = ({ api }) => {
  const [tpl, setTpl] = useState(null);
  const [tab, setTab] = useState('friendly');
  useEffect(() => { api().get('/admin/reminder-templates').then(r => setTpl(r.data)).catch(() => {}); }, [api]);
  const set = (k) => (e) => setTpl({ ...tpl, [tab]: { ...tpl[tab], [k]: e.target.value } });
  const save = async () => {
    try { const r = await api().put('/admin/reminder-templates', tpl); setTpl(r.data); toast.success('Reminder templates saved'); }
    catch (e) { toast.error(e.response?.data?.detail || 'Save failed'); }
  };
  if (!tpl) return null;
  return (
    <Card className="industrial-card" data-testid="reminder-templates-card">
      <CardHeader className="border-b border-slate-100 pb-3"><CardTitle className="text-lg">Overdue Reminder Templates</CardTitle></CardHeader>
      <CardContent className="p-4 space-y-3">
        <p className="text-sm text-slate-500">Used by "Send Reminder" on Customer History. Placeholders: <code>{'{customer_name}'}</code> <code>{'{total_overdue}'}</code> <code>{'{oldest_days}'}</code> <code>{'{company_name}'}</code></p>
        <div className="flex gap-2">
          {TONES.map(([k, l]) => <Button key={k} size="sm" variant={tab === k ? 'default' : 'outline'} onClick={() => setTab(k)} className="rounded-sm" data-testid={`reminder-tpl-tab-${k}`}>{l}</Button>)}
        </div>
        <div><Label>Subject</Label><Input value={tpl[tab].subject} onChange={set('subject')} className="rounded-sm" data-testid="reminder-tpl-subject" /></div>
        <div><Label>Message</Label><Textarea rows={9} value={tpl[tab].body} onChange={set('body')} className="rounded-sm text-sm" data-testid="reminder-tpl-body" /></div>
        <Button onClick={save} className="bg-slate-900 hover:bg-slate-800 rounded-sm" data-testid="reminder-tpl-save"><Save className="w-4 h-4 mr-1" /> Save Templates</Button>
      </CardContent>
    </Card>
  );
};

export default ReminderTemplatesSettings;
